import { inject, InjectionToken } from "@angular/core";
import { SidenavItemInterface } from "@app/shared-core/components/side-nav/interfaces/side-nav-items.interface";
import { SideNavService } from "@app/shared-core/components/side-nav/services/side-nav.service";
import { PERMISSION_CONSTANTS } from "@app/shared/auth/constants/permissions.constant";

export const sideNavConfig: SidenavItemInterface[] = [
  {
    id: "home",
    items: [],
    icon: "home",
    tooltip: "SIDE_NAV.HOME.TITLE",
    direction: "TOP",
    routerLink: "/",
    routerLinkExact: true,
  },
  {
    id: "crm",
    items: [],
    label: "CRM.TITLE",
    icon: "crm",
    tooltip: "SIDE_NAV.CRM.TITLE",
    direction: "TOP",
  },
  {
    id: "assets",
    items: [],
    label: "ASSETS.TITLE",
    icon: "devices",
    tooltip: "SIDE_NAV.ASSETS.TITLE",
    direction: "TOP",
  },
  {
    id: "fleet",
    items: [],
    label: "FLEET.TITLE",
    icon: "car",
    tooltip: "SIDE_NAV.FLEET.TITLE",
    direction: "TOP",
  },
  {
    id: "queue",
    items: [],
    label: "QUEUE.TITLE",
    icon: "tickets",
    tooltip: "SIDE_NAV.QUEUE.TITLE",
    direction: "TOP",
    routerLink: "/queue",
    permissions: [PERMISSION_CONSTANTS.QUEUE.MANAGE],
  },
  {
    id: "movements-management",
    items: [],
    label: "MOVEMENTS_MANAGEMENT.TITLE",
    icon: "movement-management",
    tooltip: "SIDE_NAV.MOVEMENTS_MANAGEMENT.TITLE",
    direction: "TOP",
  },
  {
    id: "revenue-management",
    items: [],
    label: "REVENUE_MANAGEMENT.TITLE",
    icon: "money",
    tooltip: "SIDE_NAV.REVENUE_MANAGEMENT.TITLE",
    direction: "TOP",
  },
  {
    id: "setting",
    items: [],
    label: "SETTINGS.TITLE",
    icon: "settings",
    tooltip: "SIDE_NAV.SETTINGS.TITLE",
    direction: "BTN",
  },
];

export const ADD_MAIN_LINKS = new InjectionToken("ADD_MAIN_LINKS", {
  providedIn: "root",
  factory: () => {
    const sideNavService = inject(SideNavService);
    sideNavService.setMainLinks(sideNavConfig);
  },
});
